import React, { useCallback } from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import CopyButton from '../document/copy-button';
// eslint-disable-next-line max-len
import { atomOneDarkReasonable } from 'react-syntax-highlighter/dist/cjs/styles/hljs';

import styles from './code-box.module.scss';
import { isFunction } from '../../../../utils/type';
import { IconButton } from '../../../common/icon-button/icon-button';
import { Plus as IconPlus } from 'react-bootstrap-icons'
import { UiIcon } from '../../../common/icons/ui-icon';
import { ChatDots as IconChatDots } from 'react-bootstrap-icons'
import className from 'classnames';

export interface CodeSnippetProps {
  code: string;
  language?: string;
  style?: Object;
  showCopyButton?: boolean;
  url?: string;
  runBtnClass?: string;
  runBtnFunction?: Function;
  node?: any;
  comments?: Array<Object>;
}

const CodeSnippet = ({
  code,
  language = 'text',
  style = atomOneDarkReasonable,
  showCopyButton = true,
  url,
  runBtnClass,
  runBtnFunction,
  node,
  comments
}: CodeSnippetProps) => {
  const handleRunClick = useCallback(() => {
    if (runBtnFunction && isFunction(runBtnFunction)) {
      runBtnFunction();
    }
  }, [runBtnFunction]);

  const codeBlockChildren = () => (
    <>
      <SyntaxHighlighter className="scrollable-line" language={language} style={style}>
        {code}
      </SyntaxHighlighter>
      {showCopyButton && <CopyButton className={styles.copyIcon} text={code} />}
      {url && (
        <IconButton iconSize={2} size={'lg'} icon={IconPlus}  className={runBtnClass} onClick={handleRunClick} href={url}
        target="_blank">
          Run
        </IconButton>
      )}
    </>
  )

  const generateDiv = () => {
    if (comments?.length) {
      return (
        <div 
          className={className('has-comment-code', styles.snippetContainer)}
          data-startline={node.position?.start.line}
          data-endline={node.position?.end.line}
          data-position={node.position?.start.offset}
          data-size={node.position?.end?.offset - node.position?.start.offset}
          data-comment-id={comments[0].attributes.comment_id}
        > 
          <div className={styles.commentBtn}><UiIcon icon={IconChatDots} /></div>
          {codeBlockChildren()}
        </div>
      )
    }
    return (
      <div 
        className={styles.snippetContainer}
        data-startline={node.position?.start.line}
        data-endline={node.position?.end.line}
        data-position={node.position?.start.offset}
        data-size={node.position?.end?.offset - node.position?.start.offset}
      >
        {codeBlockChildren()}
      </div>
    )
  }
  
  return (generateDiv());
};

export default CodeSnippet;
